import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@fontsource/inter';

// Normalize stray hash fragments to canonical, clean URLs before React mounts.
// - https://www.halr.ai/app#    -> /app
// - https://www.halr.ai/#/app   -> /app (legacy hash routes)
if (typeof window !== 'undefined') {
  try {
    const { hash, pathname, search } = window.location;
    // Trailing hash or hash root
    if (hash === '#' || hash === '#/' || hash === '#!') {
      window.history.replaceState({}, document.title, pathname + search);
    } else if (hash.startsWith('#/')) {
      // Legacy hash-based route -> migrate to history route
      const newPath = hash.slice(1); // keep leading slash
      window.history.replaceState({}, document.title, newPath + search);
    }
  } catch {}
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 